/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./HeroSection.css";
import { FiPhoneCall } from "react-icons/fi";

// import slide1 from "../../Component/Image/HOME/GreyColorBuilding.jpeg";
import slide1 from "../../Component/Image/BannerHome/BannerDensat1.jpeg";


import slide2 from "../../Component/Image/BannerHome/BannnerDensat2.jpeg"; // people
import slide3 from "../../Component/Image/BannerHome/BannerDensat3.jpeg";

/* slideType helps control rendering */
const slides = [
  { img: slide1, type: "bg", position: "center top" },
  { img: slide2, type: "image" }, // 👈 PEOPLE SLIDE
  { img: slide3, type: "bg", position: "center center" }
];

export default function HeroSection() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-slider">

      {/* SLIDES */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === activeSlide ? "active" : ""}`}
        >
          {slide.type === "bg" ? (
            <div
              className="hero-bg"
              style={{
                backgroundImage: `url(${slide.img})`,
                backgroundPosition: slide.position
              }}
            />
          ) : (
            <img
              src={slide.img}
              alt="Facility Staff"
              className="hero-img"
            />
          )}
        </div>
      ))}

      {/* CONTENT */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-tag">⭐ Leading Facility Management Company</div>

          <h1 className="hero-title">
            Integrated <span>Facility Management</span>
            <span> & Housekeeping Services Across</span><br />
            15 Cities in India
          </h1>

          <p className="hero-subtext">
            Creating cleaner, safer and more efficient workplaces through reliable
            soft and hard facility services.
          </p>

          <div className="hero-buttons">
            <a href="/Contact" className="btn-primary">
              Request a Free Site Assessment →
            </a>

            <a href="tel:+91-9899811123" className="btn-outline">
              <FiPhoneCall className="btn-icon" />
              Call Now for a Tailored Quote
            </a>
          </div>
        </div>
      </div>

      {/* DOTS */}
      <div className="hero-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === activeSlide ? "active" : ""}`}
            onClick={() => setActiveSlide(i)}
          />
        ))}
      </div>

    </section>
  );
}
